import * as React from "react";
const SvgMore = (props) => /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 48, height: 48, rx: 24, fill: "black", style: {
  fill: "black",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M16.4283 26.2853C17.6907 26.2853 18.714 25.2619 18.714 23.9996C18.714 22.7372 17.6907 21.7139 16.4283 21.7139C15.1659 21.7139 14.1426 22.7372 14.1426 23.9996C14.1426 25.2619 15.1659 26.2853 16.4283 26.2853Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M24.0006 26.2853C25.2629 26.2853 26.2863 25.2619 26.2863 23.9996C26.2863 22.7372 25.2629 21.7139 24.0006 21.7139C22.7382 21.7139 21.7148 22.7372 21.7148 23.9996C21.7148 25.2619 22.7382 26.2853 24.0006 26.2853Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M31.5709 26.2853C32.8332 26.2853 33.8566 25.2619 33.8566 23.9996C33.8566 22.7372 32.8332 21.7139 31.5709 21.7139C30.3085 21.7139 29.2852 22.7372 29.2852 23.9996C29.2852 25.2619 30.3085 26.2853 31.5709 26.2853Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }));
export default SvgMore;
